import { gql, useMutation } from '@apollo/client';
import React, { ReactElement, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import alertPic from '../../../assets/alert.svg';
import GenericAlert from '../../../common_lib_front/components/genericAlert/genericAlert';
import { PopUp } from '../../../common_lib_front/components/popUp/popUp';
import style from './deletePass.module.css';

export const DELETE_PASS = gql`
  mutation DeletePass($passId: String!) {
    deletePass(passId: $passId) {
      success
      error
    }
  }
`;

export default function DeletePass(): ReactElement {
  const history = useHistory();
  const { passId } = useParams<{ passId: string }>();
  const [alert, setAlert] = useState<string>('');
  const [doDelete] = useMutation(DELETE_PASS, {
    onError: e => {
      let errorMessage = 'An unexpected error occurred. Please try again later.';

      if (e.message.includes('NetworkError')) {
        errorMessage = 'Network error: Please check your internet connection.';
      } else if (e.message.includes('GraphQL error')) {
        errorMessage = 'Server error: Unable to delete the pass. Please try again later.';
      }

      setAlert(errorMessage);
    },
    onCompleted: d => {
      if (d.deletePass.success) {
        history.goBack();
      } else {
        setAlert(d.deletePass.error);
      }
    },
  });
  return (
    <PopUp title="Delete Pass" close={() => history.goBack()}>
      <div className={style.box}>
        <div className={style.alertBox}>
          <img src={alertPic} alt="" className={style.alertImg} />
          <h2>Warning:</h2>
          <h4 className={style.text}> Are you sure you want to delete this pass?</h4>
          <h4 className={style.deleteText}>
            This will deactivate the pass and it will no longer function.
          </h4>
        </div>
        <GenericAlert color="red" title={alert} hidden={!alert} />
        <div className={style.btnBox}>
          <button onClick={() => history.goBack()} className={style.cancel}>
            Cancel
          </button>
          <button
            onClick={() => doDelete({ variables: { passId } })}
            className={style.delete}
          >
            Delete
          </button>
        </div>
      </div>
    </PopUp>
  );
}
